import { render, staticRenderFns } from "./wallet.vue?vue&type=template&id=d01f2cc4&"
import script from "./wallet.vue?vue&type=script&lang=js&"
export * from "./wallet.vue?vue&type=script&lang=js&"
import style0 from "./wallet.vue?vue&type=style&index=0&id=d01f2cc4&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d01f2cc4')) {
      api.createRecord('d01f2cc4', component.options)
    } else {
      api.reload('d01f2cc4', component.options)
    }
    module.hot.accept("./wallet.vue?vue&type=template&id=d01f2cc4&", function () {
      api.rerender('d01f2cc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/wallet.vue"
export default component.exports